import { render } from "./LifePassTip.vue?vue&type=template&id=5017e1d8"
import script from "./LifePassTip.vue?vue&type=script&lang=js"
export * from "./LifePassTip.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lifepass-passes-app/lifepass-passes-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__